// This file is used to display a loading spinner overlay on the page.
if (!window.daz) {
    window.daz = {};
}

(function () {
    var SVG_INNER =
        '<circle cx="9.5" cy="47.5" r="9.5"></circle>' +
        '<circle cx="86.5" cy="47.5" r="9.5"></circle>' +
        '<path d="M48.5,18.5c-4.96,0-9-4.04-9-9S43.54.5,48.5.5s9,4.04,9,9-4.04,9-9,9Z"></path>' +
        '<path d="M48.5,1c4.69,0,8.5,3.81,8.5,8.5s-3.81,8.5-8.5,8.5-8.5-3.81-8.5-8.5,3.81-8.5,8.5-8.5M48.5,0c-5.25,0-9.5,4.25-9.5,9.5s4.25,9.5,9.5,9.5,9.5-4.25,9.5-9.5S53.75,0,48.5,0h0Z"></path>' +
        '<circle cx="48.5" cy="9.5" r="9.5"></circle>' +
        '<circle cx="48.5" cy="86.5" r="9.5"></circle>';

    function resolveElement(target) {
        if (!target) {
            return null;
        }
        if (target.nodeType === 1) {
            return target;
        }
        if (typeof target === 'string') {
            if (target.charAt(0) === '#') {
                return document.getElementById(target.slice(1));
            }
            return document.querySelector(target);
        }
        return null;
    }

    function overlayMarkup(options) {
        var opts = options || {};
        var idAttr = opts.id ? ' id="' + String(opts.id).replace(/"/g, '') + '"' : '';
        var hiddenAttr = opts.hidden ? ' hidden' : '';
        var hiddenClass = opts.visible === false ? ' bs5-d-none' : '';
        var inlineClass = opts.inline ? ' daz-loading-overlay--inline' : '';
        var label = opts.label != null ? opts.label : 'Loading...';

        return (
            '<div class="daz-loading-overlay outlet-loading-spinner-container' + inlineClass + hiddenClass + '"' +
            idAttr + hiddenAttr + '>' +
            '<p>' + label + '</p>' +
            '<svg class="daz-loading-spinner loading-spinner" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 96 96" aria-hidden="true">' +
            SVG_INNER +
            '</svg>' +
            '</div>'
        );
    }

    daz.loading = {
        svgInner: SVG_INNER,

        markup: function (options) {
            return overlayMarkup(options);
        },

        mount: function (target, options) {
            var parent = resolveElement(target);
            if (!parent) {
                return null;
            }

            var opts = options || {};
            if (opts.id && document.getElementById(opts.id)) {
                return document.getElementById(opts.id);
            }

            parent.insertAdjacentHTML('beforeend', overlayMarkup(opts));
            return opts.id ? document.getElementById(opts.id) : parent.lastElementChild;
        },

        get: function (target) {
            return resolveElement(target);
        },

        show: function (target) {
            var el = resolveElement(target);
            if (!el) {
                return;
            }
            el.style.display = '';
            el.classList.remove('bs5-d-none');
            el.removeAttribute('hidden');
        },

        hide: function (target) {
            var el = resolveElement(target);
            if (!el) {
                return;
            }
            el.style.display = 'none';
            el.classList.add('bs5-d-none');
        },

        toggle: function (target, visible) {
            if (visible) {
                this.show(target);
            } else {
                this.hide(target);
            }
        }
    };
})();
